import { Autocomplete, Box, Grid, TextField } from "@mui/material";
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import SelectFormItem from "components/Input/Select";
import yupFormSchemas from "components/FormItem/yupFormSchemas";
import { CheckboxFormItem, InputNumberForm, TextBoxForm } from "components/Input";
import Divider from "components/Divider";
import "./Register.css";
import { FiArrowRight, FiArrowLeft } from "react-icons/fi";
import React from "react";
import { RegisterContext } from "..";
import { undefinedOrNull } from "utilities/Function";
const StepForm2 = () => {
  const { handleNext, handleBack, objMasterData, formStep2,
    GetDistrictRegister, GetTambonRegister,
    arrDistrict1, arrDistrict2, arrTambon1, arrTambon2, isSameAddress, setisSameAddress } = React.useContext(RegisterContext);

  return (
    <FormProvider {...formStep2}>
      <Grid container direction="row" xs={12} md={12} sx={{}} spacing={2} marginBottom={1}>
        <Grid item md={12} xs={12}>
          <Divider>ที่อยู่ตามทะเบียนบ้าน</Divider>
        </Grid>
        <Grid item md={4} xs={12}>
          <TextBoxForm name={"sVillage1"} label={"หมู่บ้าน/ตึก/ชั้น/ห้องที่"} maxLength={250} />
        </Grid>
        <Grid item md={2} xs={12}>
          <TextBoxForm name={"sHouseNumber1"} label={"เลขที"} required maxLength={20} />
        </Grid>
        <Grid item md={2} xs={12}>
          <InputNumberForm name={"nMoo1"} label={"หมู่ที่"} maxDigits={0} />
        </Grid>
        <Grid item md={2} xs={12}>
          <TextBoxForm name={"sChoi1"} label={"ชอย"} maxLength={100} />
        </Grid>
        <Grid item md={2} xs={12}>
          <TextBoxForm name={"sRoad1"} label={"ถนน"} maxLength={100} />
        </Grid>

        <Grid item md={3} xs={12}>
          <SelectFormItem options={objMasterData?.lstProvince || []} name={"nProvince1ID"} label={"จังหวัด"} required
            onChange={(val) => {
              if (val) {
                formStep2.setValue("nDistrict1ID", null);
                formStep2.setValue("nSubDistrict1ID", null);
                formStep2.setValue("sZipCode1", null);
                GetDistrictRegister(undefinedOrNull(val.value, "number"), 1);
              }
            }} />
        </Grid>

        <Grid item md={3} xs={12}>
          <SelectFormItem options={arrDistrict1 || []} name={"nDistrict1ID"} label={"อำเภอ/เขต"} required onChange={(val) => {
            if (val) {
              formStep2.setValue("nSubDistrict1ID", null);
              formStep2.setValue("sZipCode1", null);
              GetTambonRegister(undefinedOrNull(val.value, "number"), 1);
            }
          }} />
        </Grid>

        <Grid item md={3} xs={12}>
          <SelectFormItem options={arrTambon1 || []} name={"nSubDistrict1ID"} label={"ตำบล/แขวง"} required onChange={(val) => {
            if (val) {
              formStep2.setValue("sZipCode1", undefinedOrNull(val.valueOther, "string"));
            }
            formStep2.setError("sZipCode1");
          }} />
        </Grid>
        <Grid item md={3} xs={12}>
          <TextBoxForm name={"sZipCode1"} label={"รหัสไปรษณีย์"} required maxLength={10} />
        </Grid>
        <Grid item md={12} xs={12}>
          <Divider><div id="divSameAddress"><p style={{ marginRight: "10px" }}>ที่อยู่ปัจจุบัน (ที่สามารถติดต่อได้)</p> <CheckboxFormItem name="isSameAddress" label="ที่อยู่เดียวกับทะเบียนบ้าน" onChange={(e) => {
            if (e) {
              formStep2.setValue("sVillage2", formStep2.getValues("sVillage1"));
              formStep2.setValue("sHouseNumber2", formStep2.getValues("sHouseNumber1"));
              formStep2.setValue("nMoo2", formStep2.getValues("nMoo1"));
              formStep2.setValue("sChoi2", formStep2.getValues("sChoi1"));
              formStep2.setValue("sRoad2", formStep2.getValues("sRoad1"));
              formStep2.setValue("nProvince2ID", formStep2.getValues("nProvince1ID"));
              GetDistrictRegister(undefinedOrNull(formStep2.getValues("nProvince1ID"), "number"), 2);
              formStep2.setValue("nDistrict2ID", formStep2.getValues("nDistrict1ID"));
              GetTambonRegister(undefinedOrNull(formStep2.getValues("nDistrict1ID"), "number"), 2);
              formStep2.setValue("nSubDistrict2ID", formStep2.getValues("nSubDistrict1ID"));
              formStep2.setValue("sZipCode2", formStep2.getValues("sZipCode1"));
              formStep2.clearErrors();
              setisSameAddress(true);

            } else {
              formStep2.setValue("sVillage2", null);
              formStep2.setValue("sHouseNumber2", null);
              formStep2.setValue("nMoo2", null);
              formStep2.setValue("sChoi2", null);
              formStep2.setValue("sRoad2", null);
              formStep2.setValue("nProvince2ID", null);
              formStep2.setValue("nDistrict2ID", null);
              formStep2.setValue("nSubDistrict2ID", null);
              formStep2.setValue("sZipCode2", null);
              formStep2.clearErrors();
              setisSameAddress(false);
            }
          }} /></div> </Divider>
        </Grid>
        <Grid item md={4} xs={12}>
          <TextBoxForm name={"sVillage2"} label={"หมู่บ้าน/ตึก/ชั้น/ห้องที่"} disabled={isSameAddress} maxLength={250} />
        </Grid>
        <Grid item md={2} xs={12}>
          <TextBoxForm name={"sHouseNumber2"} label={"เลขที"} disabled={isSameAddress} required maxLength={20} />
        </Grid>
        <Grid item md={2} xs={12}>
          <InputNumberForm name={"nMoo2"} label={"หมู่ที่"} disabled={isSameAddress} maxDigits={0} />
        </Grid>
        <Grid item md={2} xs={12}>
          <TextBoxForm name={"sChoi2"} label={"ชอย"} disabled={isSameAddress} maxLength={100} />
        </Grid>
        <Grid item md={2} xs={12}>
          <TextBoxForm name={"sRoad2"} label={"ถนน"} disabled={isSameAddress} maxLength={100} />
        </Grid>

        <Grid item md={3} xs={12}>
          <SelectFormItem options={objMasterData?.lstProvince || []} name={"nProvince2ID"} label={"จังหวัด"} required
            onChange={(val) => {
              if (val) {
                formStep2.setValue("nDistrict2ID", null);
                formStep2.setValue("nSubDistrict2ID", null);
                formStep2.setValue("sZipCode2", null);
                GetDistrictRegister(undefinedOrNull(val.value, "number"), 2);
              }
            }} disabled={isSameAddress} />
        </Grid>

        <Grid item md={3} xs={12}>
          <SelectFormItem options={arrDistrict2 || []} name={"nDistrict2ID"} label={"อำเภอ/เขต"} required
            onChange={(val) => {
              if (val) {
                formStep2.setValue("nSubDistrict2ID", null);
                formStep2.setValue("sZipCode2", null);
                GetTambonRegister(undefinedOrNull(val.value, "number"), 2);
              }
            }} disabled={isSameAddress} />
        </Grid>

        <Grid item md={3} xs={12}>
          <SelectFormItem options={arrTambon2 || []} name={"nSubDistrict2ID"} label={"ตำบล/แขวง"} required
            onChange={(val) => {
              if (val) {
                formStep2.setValue("sZipCode2", undefinedOrNull(val.valueOther, "string"));
              }
              formStep2.setError("sZipCode2");
            }} disabled={isSameAddress} />
        </Grid>
        <Grid item md={3} xs={12}>
          <TextBoxForm name={"sZipCode2"} label={"รหัสไปรษณีย์"} required disabled={isSameAddress} maxLength={10} />
        </Grid>


        <Grid item md={3} xs={12}>
          <TextBoxForm name={"sEmail"} label={"อีเมล์"} required maxLength={50} />
        </Grid>
        <Grid item md={3} xs={12}>
          <TextBoxForm name={"sIDLine"} label={"ID Line"} maxLength={50} />
        </Grid>
        <Grid item md={3} xs={12}>
          <TextBoxForm name={"sFacebook"} label={"Facebook"} />
        </Grid>
        <Grid item md={3} xs={12}>
          <TextBoxForm name={"sMobileNumber"} label={"เบอร์มือถือ"} lang="number" required maxLength={10} />
        </Grid>

        <Grid item md={12} xs={12}>
          <Divider>บุคคลที่ติดต่อกรณีเร่งด่วน</Divider>
        </Grid>
        <Grid item md={3} xs={12}>
          <SelectFormItem options={objMasterData?.lstRelationship1 || []} name={"sRelationshipID"} label={"ความสัมพันธ์ "} required />
        </Grid>
        <Grid item md={3} xs={12}>
          <TextBoxForm name={"sContactFName"} label={"ชื่อบิดา/มารดา/หรือญาติ"} required maxLength={250} />
        </Grid>
        <Grid item md={3} xs={12}>
          <TextBoxForm name={"sContactLName"} label={"นามสกุล"} required maxLength={150} />
        </Grid>

        <Grid item md={3} xs={12}>
          <TextBoxForm name={"sContactMobile"} label={"เบอร์มือถือ"} lang="number" required maxLength={10} />
        </Grid>

        <Grid item md={3} xs={12}>
          <TextBoxForm name={"sRelationship1"} label={"ความสัมพันธ์"} maxLength={250} required />
        </Grid>
        <Grid item md={3} xs={12}>
          <TextBoxForm name={"sContactFName1"} label={"ชื่อบุคคลอื่นๆ"} maxLength={250} required />
        </Grid>
        <Grid item md={3} xs={12}>
          <TextBoxForm name={"sContactLName1"} label={"นามสกุล"} maxLength={150} required />
        </Grid>

        <Grid item md={3} xs={12}>
          <TextBoxForm name={"sContactMobile1"} label={"เบอร์มือถือ"} lang="number" maxLength={10} required />
        </Grid>

        <Grid item md={6} xs={6}>
          <Grid marginTop={4} container direction="row" alignItems="start" justifyContent="start" sx={{}}>
            <button className="buttonBack" onClick={handleBack}>
              <FiArrowLeft />
              <span>กลับ</span>
            </button>
          </Grid>
        </Grid>
        <Grid item md={6} xs={6}>
          <Grid marginTop={4} container direction="row" alignItems="end" justifyContent="end" sx={{}}>
            <button className="buttonNext" onClick={formStep2.handleSubmit(() => { handleNext(); })}>
              <span>ต่อไป</span>
              <FiArrowRight />
            </button>
          </Grid>
        </Grid>



      </Grid>
    </FormProvider>
  )
};

export default StepForm2;

const top100Films = [
  { label: 'The Shawshank Redemption', value: 1994 },
  { label: 'The Godfather', value: 1972 },
  { label: 'The Godfather: Part II', value: 1974 },
  { label: 'The Dark Knight', value: 2008 },
  { label: '12 Angry Men', value: 1957 },
  { label: "Schindler's List", value: 1993 },
  { label: 'Pulp Fiction', value: 1994 },
  {
    label: 'The Lord of the Rings: The Return of the King',
    value: 2003,
  },
  { label: 'The Good, the Bad and the Ugly', value: 1966 },
  { label: 'Fight Club', value: 1999 },
  {
    label: 'The Lord of the Rings: The Fellowship of the Ring',
    value: 2001,
  },
  {
    label: 'Star Wars: Episode V - The Empire Strikes Back',
    value: 1980,
  },
  { label: 'Forrest Gump', value: 1994 },
  { label: 'Inception', value: 2010 },
  {
    label: 'The Lord of the Rings: The Two Towers',
    value: 2002,
  },
  { label: "One Flew Over the Cuckoo's Nest", value: 1975 },
  { label: 'Goodfellas', value: 1990 },
  { label: 'The Matrix', value: 1999 },
  { label: 'Seven Samurai', value: 1954 },
  {
    label: 'Star Wars: Episode IV - A New Hope',
    value: 1977,
  },
  { label: 'City of God', value: 2002 },
  { label: 'Se7en', value: 1995 },
  { label: 'The Silence of the Lambs', value: 1991 },
  { label: "It's a Wonderful Life", value: 1946 },
  { label: 'Life Is Beautiful', value: 1997 },
  { label: 'The Usual Suspects', value: 1995 },
  { label: 'Léon: The Professional', value: 1994 },
  { label: 'Spirited Away', value: 2001 },
  { label: 'Saving Private Ryan', value: 1998 },
  { label: 'Once Upon a Time in the West', value: 1968 },
  { label: 'American History X', value: 1998 },
  { label: 'Interstellar', value: 2014 },
  { label: 'Casablanca', value: 1942 },
  { label: 'City Lights', value: 1931 },
  { label: 'Psycho', value: 1960 },
  { label: 'The Green Mile', value: 1999 },
  { label: 'The Intouchables', value: 2011 },
  { label: 'Modern Times', value: 1936 },
  { label: 'Raiders of the Lost Ark', value: 1981 },
  { label: 'Rear Window', value: 1954 },
  { label: 'The Pianist', value: 2002 },
  { label: 'The Departed', value: 2006 },
  { label: 'Terminator 2: Judgment Day', value: 1991 },
  { label: 'Back to the Future', value: 1985 },
  { label: 'Whiplash', value: 2014 },
  { label: 'Gladiator', value: 2000 },
  { label: 'Memento', value: 2000 },
  { label: 'The Prestige', value: 2006 },
  { label: 'The Lion King', value: 1994 },
  { label: 'Apocalypse Now', value: 1979 },
  { label: 'Alien', value: 1979 },
  { label: 'Sunset Boulevard', value: 1950 },
  {
    label: 'Dr. Strangelove or: How I Learned to Stop Worrying and Love the Bomb',
    value: 1964,
  },
  { label: 'The Great Dictator', value: 1940 },
  { label: 'Cinema Paradiso', value: 1988 },
  { label: 'The Lives of Others', value: 2006 },
  { label: 'Grave of the Fireflies', value: 1988 },
  { label: 'Paths of Glory', value: 1957 },
  { label: 'Django Unchained', value: 2012 },
  { label: 'The Shining', value: 1980 },
  { label: 'WALL·E', value: 2008 },
  { label: 'American Beauty', value: 1999 },
  { label: 'The Dark Knight Rises', value: 2012 },
  { label: 'Princess Mononoke', value: 1997 },
  { label: 'Aliens', value: 1986 },
  { label: 'Oldboy', value: 2003 },
  { label: 'Once Upon a Time in America', value: 1984 },
  { label: 'Witness for the Prosecution', value: 1957 },
  { label: 'Das Boot', value: 1981 },
  { label: 'Citizen Kane', value: 1941 },
  { label: 'North by Northwest', value: 1959 },
  { label: 'Vertigo', value: 1958 },
  {
    label: 'Star Wars: Episode VI - Return of the Jedi',
    value: 1983,
  },
  { label: 'Reservoir Dogs', value: 1992 },
  { label: 'Braveheart', value: 1995 },
  { label: 'M', value: 1931 },
  { label: 'Requiem for a Dream', value: 2000 },
  { label: 'Amélie', value: 2001 },
  { label: 'A Clockwork Orange', value: 1971 },
  { label: 'Like Stars on Earth', value: 2007 },
  { label: 'Taxi Driver', value: 1976 },
  { label: 'Lawrence of Arabia', value: 1962 },
  { label: 'Double Indemnity', value: 1944 },
  {
    label: 'Eternal Sunshine of the Spotless Mind',
    value: 2004,
  },
  { label: 'Amadeus', value: 1984 },
  { label: 'To Kill a Mockingbird', value: 1962 },
  { label: 'Toy Story 3', value: 2010 },
  { label: 'Logan', value: 2017 },
  { label: 'Full Metal Jacket', value: 1987 },
  { label: 'Dangal', value: 2016 },
  { label: 'The Sting', value: 1973 },
  { label: '2001: A Space Odyssey', value: 1968 },
  { label: "Singin' in the Rain", value: 1952 },
  { label: 'Toy Story', value: 1995 },
  { label: 'Bicycle Thieves', value: 1948 },
  { label: 'The Kid', value: 1921 },
  { label: 'Inglourious Basterds', value: 2009 },
  { label: 'Snatch', value: 2000 },
  { label: '3 Idiots', value: 2009 },
  { label: 'Monty Python and the Holy Grail', value: 1975 },
];